module.exports = __webpack_public_path__ + "img/quickspin.f598c72d.png";